

















































































































































































































































































	import {Prop} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';
	import {Stored} from "vue-stored-prop-decorator/index";
	import storeUser from "@/stores/modules/user";
	import { createStore } from 'devextreme-aspnet-data-nojquery';
	import {Token, User} from "@/models";
	import storeToken from "@/stores/modules/token";
	import {
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRequiredRule,
			DxRangeRule,
			DxValueFormat,
			DxPaging,
			DxPager,
			DxStateStoring,
		} from 'devextreme-vue/data-grid';
import {Achat, BoisType, LongueursAchat} from '@/models';

import CrudAchatFilter from '@/components/Crud/Achat/Filter.vue';
import CrudAchatEditDialog from '@/components/Crud/Achat/EditDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import {ResultType} from '@/shared/xhttp';
import storeLongueursAchat from "@/stores/modules/longueursAchat";
import storeBoisType from "@/stores/modules/boisType";

import storeAchat, {AchatFilterList} from '@/stores/modules/achat';
import DxButton from 'devextreme-vue/button';

	@Component({
		components: {
			DxButton,
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRangeRule,
			DxRequiredRule,
			DxValueFormat,
			DxPaging,
			DxPager,		
			DxStateStoring,
			CrudAchatEditDialog,
			CrudDeleteDialog,
			}
	})

	export default class CrudAchatList extends Vue {
		
		@Stored(() => storeToken) token!: Token;

		@Stored(() => storeAchat) private achats!: ResultType<Achat>;
		@Stored(() => storeAchat) private filters!: AchatFilterList;

		private storeLongueursAchat = storeLongueursAchat
		private storeBoisType = storeBoisType;
		//private selectedBoisType: BoisType = null;
		//private selectLongueurAchat: LongueursAchat = null;

		private editAchat: Achat = null;
		private deletedAchat: Achat = null;
		private storeAchat = storeAchat;
		private dataGrid;

		private url = process.env.VUE_APP_BACK_BASE_URL + '/api/achats'

		private dataSource = createStore({
			key: 'id',
			loadUrl: `${this.url}/fetch/${this.filters.BoisType?this.filters.BoisType.id:0}/${this.filters.LongueurAchat?this.filters.LongueurAchat.id:0}/${this.filters.Coupe_fini}`,
			onBeforeSend: (method, ajaxOptions) => {
				ajaxOptions.xhrFields = { withCredentials: true };
				ajaxOptions.headers = {
					'Authorization': 'BEARER ' + this.token.id
				}
			},
		});

		public async mounted(): Promise<void> 
		{
			await storeLongueursAchat.dispatch('getC', {filters: false});
			await storeBoisType.dispatch('getC', {filters: false});
			this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		}

		public refresh()
		{
			// on change la source
			this.dataSource = createStore({
					key: 'id',
					loadUrl: `${this.url}/fetch/${this.filters.BoisType?this.filters.BoisType.id:0}/${this.filters.LongueurAchat?this.filters.LongueurAchat.id:0}/${this.filters.Coupe_fini}`,
					onBeforeSend: (method, ajaxOptions) => {
						ajaxOptions.xhrFields = { withCredentials: true };
						ajaxOptions.headers = {
							'Authorization': 'BEARER ' + this.token.id
						}
					},
				});
		}

		private OnEditAchat(id)
		{
			let achat = new Achat()
			achat.id = id;
			this.editAchat = achat
		}
		
		private OnDeletedAchat(id)
		{
			let achat = new Achat()
			achat.id = id;
			this.deletedAchat = achat
		}

		public clearFilters() {
			this.filters.BoisType = null;
			this.filters.LongueurAchat = null;
			this.filters.Coupe_fini = true;
			this.dataGrid.instance.clearFilter()
			this.dataGrid.instance!.state(null);
			this.refresh();
		}

		private calculateCellValue(data) {
			let date = data.date
			let year = date.substr(0,4)
			let month = date.substr(5,2)
			let day = date.substr(8,2)
			return day + '/' + month + '/' + year
		}

		private calculateCellValueCoupe(data) {
			let date = data.date_coupe
			let year = date.substr(0,4)
			let month = date.substr(5,2)
			let day = date.substr(8,2)
			return day + '/' + month + '/' + year
		}

		public onRowPrepared(e) {
            if (e.rowType === "data") {
                if ((e.dataIndex % 2) != 0) {
                    e.rowElement.style.cssText = "background-color: #eeeeee;";
				}
                if (e.data.fin_coupe == "1") {
                    e.rowElement.style.cssText = "color: gray; background-color: lightgreen;";
                }
            }
        }		
	}
